import PropTypes from 'prop-types';
import React from 'react';

import useArticle from '../../hooks/use_article';
import useTranslation from '../../hooks/use_translation';
import SampleIcon from '../framework/svgs/icons/sample-icon';
import Trans from '../translation/trans';

const SamplingType = ({ className, product_id }) => {
	const { t } = useTranslation('component_test_sampling_type');

	const { items: articles } = useArticle({
		include_products: [product_id],
		include_types: ['sampling'],
	});
	if (!articles || !articles.length) return <></>;

	return (
		<>
			{articles.map((article, index) => {
				const label_key = `sampling-label-${article.article_variant.article_variant_id}`;
				const offcanvas_key = `sampling-offcanvas-${article.article_variant.article_variant_id}`;

				return (
					<span key={index}>
						<span
							aria-controls={offcanvas_key}
							className={className}
							data-bs-target={`#${offcanvas_key}`}
							data-bs-toggle="offcanvas"
							role="button"
						>
							<SampleIcon cl />

							{article.article_variant.subtitle}
						</span>
						<div
							aria-labelledby={label_key}
							className="offcanvas offcanvas-end"
							id={offcanvas_key}
						>
							<div className="offcanvas-header">
								<h5 id={label_key}>{article.article_variant.title}</h5>
								<button
									aria-label="Close"
									className="btn-close text-reset"
									data-bs-dismiss="offcanvas"
									type="button"
								></button>
							</div>
							<div className="offcanvas-body">
								<Trans defaults={article.article_variant.content} t={t} />
							</div>
						</div>
					</span>
				);
			})}
		</>
	);
};

SamplingType.propTypes = {
	className: PropTypes.string,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SamplingType;
